import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import { storyblokLinkToYocoLink } from "../../../../utils/storyblok"

import BentoCard from "@components/V2/Cards/BentoCard"

const StoryblokBentoCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.BentoCard>) => {
  return (
    <BentoCard
      image={blok?.image?.filename}
      videoUrl={storyblokLinkToYocoLink(blok.videoUrl)?.url ?? ""}
      title={blok.title}
      description={blok.description}
      backgroundColor={blok.backgroundColor}
      imageAsBackground={blok.imageAsBackground}
      imageFullHeight={blok.imageFullHeight}
      size={blok.size}
      imageAlt={blok?.image?.alt}
      showDescriptionOnHover={blok.showDescriptionOnHover}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      mobileGridOrder={mobileGridOrder}
      paymentStrip={blok.paymentStrip?.filename}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokBentoCard
